import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
    Box
} from '@mui/material';
import { When } from 'react-if';
import { NoData } from '../../../../components';
import {getCrimeScoreBg} from "../../../../helpers/crimeScore";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CrimeMeterSlider from "../../../../components/crime-meter-slider"

interface CrimeData {
    crimeScore: number;
    crimeRisk: string;
    description: string;
}

const columns = [
    {
        field: 'crimeScore',
        headerName: 'Crime Score',
        width: 350,
    },
    {
        field: 'crimeRisk',
        headerName: 'Risk Level',
        width: 350,
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 350,
    },
];

interface Props {
    data: CrimeData[];
}

export const CrimeReportList: React.FC<Props> = ({ data }) => {
    let crimeScore = data?data[0]?.crimeScore : 0
    return (
        <Stack>
            <Box
                sx={{
                    marginBottom: 2
                }}
            >
                <Typography fontSize={14} fontWeight={500} lineHeight={"24px"}>
                    Crime Score
                </Typography>
            </Box>
            <Card className={"div-border-for-download"} sx={{minHeight: 250 }}>
                <TableContainer sx={{overflow:'unset'}}>
                    <Table sx={{ mb: 2 }}>
                        <TableHead>
                            <TableRow>
                                {columns?.map((column, index) => (
                                    <TableCell key={index} sx={{backgroundColor:'#11A7E2'}}>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'primary.contrastText' }}
                                        >
                                            {column?.headerName}
                                        </Typography>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((report,index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        ':hover': {
                                            backgroundColor: '#F0F0F0',
                                            cursor: 'pointer',
                                        },
                                    }}
                                >
                                    <TableCell sx={{ width: "180px" }}>
                                        <Box sx={{display:'flex',gap:'5px',alignSelf:'flex-end',flexDirection:'row'}}>
                                            <Typography
                                                variant="body2"
                                                sx={{ color: 'text.secondary' }}
                                            >
                                                {report?.crimeScore || 'N/A'}
                                            </Typography>
                                            <When condition={crimeScore}>
                                                <Typography
                                                    sx={{color:getCrimeScoreBg(report?.crimeRisk)}}
                                                >
                                                    <ReportProblemIcon/>
                                                </Typography>
                                            </When>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ width: "180px" }}>
                                        <When condition={crimeScore}>
                                            <Box sx={{
                                                height: 22,
                                                minWidth: 22,
                                                lineHeight: 0,
                                                borderRadius: 8,
                                                cursor: 'default',
                                                alignItems: 'center',
                                                whiteSpace: 'nowrap',
                                                display: 'inline-flex',
                                                justifyContent: 'center',
                                                padding:'10px 14px',
                                                position:'relative',
                                                backgroundColor : getCrimeScoreBg(report?.crimeRisk),
                                                color: report?.crimeRisk === "Moderate Risk" ? "text.secondary" : "primary.contrastText"
                                            }}>
                                                <span className={'text-download-adjust'}>
                                                    {report?.crimeRisk || 'N/A'}
                                                </span>
                                            </Box>
                                        </When>
                                        <When condition={!crimeScore}>
                                            <Typography
                                                variant="body2"
                                                sx={{ color: 'text.secondary' }}
                                            >
                                                {report?.crimeRisk}
                                            </Typography>
                                        </When>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {report?.description}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <When condition={crimeScore}>
                        <Stack mt={5}>
                            <Box sx={{margin:'auto'}}>
                                <CrimeMeterSlider value={crimeScore}/>
                            </Box>
                        </Stack>
                    </When>
                    <When
                        condition={
                            data?.length === 0
                        }
                    >
                        <div className={'div-border-for-download'}>
                            <NoData
                                buttonText={null}
                                onClick={() => {}}
                                title={'No records found'}
                                description={
                                    'No crime report found at this location.'
                                }
                            />
                        </div>
                    </When>
                </TableContainer>
            </Card>
        </Stack>
    );
};
